import React, { useState, useEffect, useContext } from 'react';
import { ThemeContext } from "styled-components";
import { useTranslation } from "react-i18next";
import { api } from "../../services/axios";
import Toast from "../../components/Toast";
import InputMask from 'react-input-mask';
import {
  Box, Grid, Modal, Tooltip, TextField, CircularProgress,
  FormControl, MenuItem, InputLabel, ListItemIcon, Select, Fab, Button,
  ListItemText, Checkbox, Backdrop,
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TablePagination
} from '@mui/material';
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs, { Dayjs } from 'dayjs';
import 'dayjs/locale/pt-br';
import 'dayjs/locale/en-gb';
import 'dayjs/locale/es';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import AddIcon from '@mui/icons-material/Add';
import { FiEdit } from "react-icons/fi";
import { AiTwotoneDelete } from "react-icons/ai";
import { tint } from "polished";
import { shade } from "polished";
import {
  IconeSearch, IconClear, TitleModal, Overlay, Content,
  CloseModal, Btn, BtnCancel
} from "../styles";

interface Operation {
  id: number;
  name: string;
};

export default function Person() {
  const { t } = useTranslation();
  const { colors } = useContext(ThemeContext);
  const [msgModal, setMsgModal] = useState("");
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [openColaborador, setOpenColaborador] = useState(false);
  const handleOpenColaborador = () => setOpenColaborador(true);
  const handleCloseColaborador = () => setOpenColaborador(false);
  const [name, setName] = useState("");
  const [dtAdmissao, setDtAdmissao] = useState<Dayjs | null>(dayjs);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(9);
  const [typeContract, setTypeContract] = useState([]);
  const [team, setTeam] = useState<Operation[]>([]);
  const [interval, setIenterval] = useState([]);
  const sex = [
    { id: "F", name: t("person.feminine") },
    { id: "M", name: t("person.masculine") }
  ];
  const status = [
    { id: "1", name: t("person.active") },
    { id: "2", name: t("person.inactive") }
  ];
  const profile = [
    { id: "1", name: t("person.administrator") },
    { id: "2", name: t("person.collaborator") }
  ];

  const [values, setValues] = useState({
    enrollment: "",
    name: "",
    email: "",
    status: "",
    teamId: "",
    companyId: 0
  });

  const [profileSelect, setProfileSelect] = useState<string[]>([]);
  const isAllProfileSelected = profile.length > 0 && profileSelect.length === profile.length;
  const [teamSelect, setTeamSelect] = useState<string[]>([]);
  const isAllSelected = team.length > 0 && teamSelect.length === team.length;
  const [servicePersonSelect, setServicePersonSelect] = useState("");
  const [notServicePerson, setNotServicePerson] = useState([]);
  const [servicePerson, setServicePerson] = useState([{
    id: 0,
    serviceId: 0,
    serviceName: ""
  }]);
  const [valuesPerson, setOptions] = useState([{
    id: 0,
    externalCode: "",
    enrollment: "",
    cpf: "",
    name: "",
    familyName: "",
    sex: "",
    phone: "",
    mobile: "",
    email: "",
    cargo: "",
    pis: "",
    dtAdmissao: "",
    ctps: "",
    urlAvatar: 0,
    status: 0,
    companyId: 0,
    companyName: "",
    typeContractId: "",
    typeContractName: "",
    intervalId: "",
    intervalName: "",
    teamId: "",
    teamName: "",
    profile: [
      {
        profileId: "",
        profileName: ""
      }
    ],
    logChange: 0
  }]);
  const [valuesEdit, setEdit] = useState({
    action: 0,
    title: "",
    id: 0,
    externalCode: "",
    enrollment: "",
    cpf: "",
    name: "",
    familyName: "",
    sex: "",
    phone: "",
    mobile: "",
    email: "",
    cargo: "",
    pis: "",
    dtAdmissao: "",
    ctps: "",
    urlAvatar: 0,
    status: "",
    companyId: 0,
    typeContractId: "",
    intervalId: "",
    teamId: "",
    profile: [{
      profileId: ""
    }],
    logChange: 0,
    locale: ""
  });

  interface Prof {
    profileId: string;
  };

  const style = {
    position: "relative",
    width: "100%",
    padding: "40px 10px 10px",
    bgcolor: colors.c01,
    border: '0',
    boxShadow: 0,
    height: '96vh',
    color: colors.c04
  };

  const styleInput = {
    background: 'transparent',
    margin: '10px',
    input: {
      color: colors.c04
    },
    "input:-webkit-autofill, input:-webkit-autofill:focus": {
      transition: 'background-color 600000s 0s, color 600000s 0s'
    },
    '& .MuiSvgIcon-root': {
      color: colors.c04, // Cor do ícone
    },
    '& .MuiPickersDay-root': {
      color: colors.c04, // Cor dos dias
      '&.Mui-selected': {
        backgroundColor: colors.c01, // Fundo do dia selecionado
        color: colors.c04, // Cor do texto do dia selecionado
      },
      '&.Mui-selected:hover': {
        backgroundColor: shade(0.1, colors.c01), // Fundo ao passar o mouse no dia selecionado
      },
    },
    '& .MuiDateCalendar-root': {
      backgroundColor: colors.c01, // Fundo do cabeçalho
    },
    '& .MuiPickersSlideTransition-root': {
      backgroundColor: colors.c01, // Fundo do calendário
    },
    // Root class for the input field
    "& .MuiOutlinedInput-root": {
      background: 'transparent',
      borderColor: colors.c04,
      color: colors.c04,
      '& fieldset': { borderColor: colors.c04 },
      '&:hover fieldset': { borderColor: colors.c04 },
      '&.Mui-focused fieldset': { borderColor: colors.c04 },
      // Class for the border around the input field
      "& .MuiOutlinedInput-notchedOutline": {
        background: 'transparent',
        borderColor: colors.c04,
        borderWidth: "1px",
      },
    },
    // Class for the label of the input field
    "& .MuiInputLabel-outlined": {
      background: 'transparent',
      color: colors.c04
    },
    fieldset: {
      border: 0
    },
    "& label.Mui-focused": {
      background: 'transparent',
      color: colors.c04
    },
    "& .MuiInput-underline:after": {
      background: 'transparent',
      borderBottomColor: colors.c04
    },
  };

  const styleSelect = {
    margin: '2px 0 0 0',
    backgroundColor: colors.c01,
    color: colors.c04, // cor do texto
    '& .MuiSelect-icon': { color: colors.c04 }, // ícone de seta do Select
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: colors.c04, // cor da borda quando não focada
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: shade(0.1, colors.c04), // cor da borda ao passar o mouse
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: colors.c04, // cor da borda ao focar
    }
  };

  const styleMenuSelect = {
    backgroundColor: colors.c01, // Cor de fundo
    color: colors.c04, // Cor do texto
    '&.MuiMenuItem-root': { backgroundColor: colors.c01 },
    '&:hover': {
      backgroundColor: shade(0.1, colors.c01), // Cor ao passar o mouse
      color: colors.c04, // Cor do texto ao passar o mouse
    },
    '&.Mui-selected': {
      backgroundColor: shade(0.2, colors.c01), // Cor do item selecionado
      color: colors.c04, // Cor do texto no item selecionado
    },
    '&.Mui-selected:hover': {
      backgroundColor: colors.c01, // Cor ao passar o mouse no item selecionado
    }
  };

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuPr = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250
      }
    },
    getContentAnchorEl: null,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "center"
    },
    transformOrigin: {
      vertical: "top",
      horizontal: "center"
    },
    variant: "menu"
  };

  const getInit = async () => {
    try {
      var IdCompany = 1;
      setValues({ ...values, companyId: IdCompany });
      setEdit({ ...valuesEdit });
      setMsgModal("Pesquisando, aguarde!");
      setPage(0);
      handleOpen();
      const response = await api.get('/person?companyId=' + IdCompany + '&status=1')
      if (response.status === 200) {
        const { result } = response.data;
        setOptions(result)
      } else if (response.status === 400) {
        Toast({ type: "warn", message:  response.data.message });
      } else {
        Toast({ type: "error", message: response.data.message });
      }
      handleClose();
      getTypeAgreement(IdCompany);
      getTeam(IdCompany);
      getIenterval(IdCompany);
    } catch (err) {
      handleClose();
      Toast({ type: "error", message: "Erro Geral, contate o suporte." });
    }
  };

  useEffect(() => {
    getInit();
  }, []);

  useEffect(() => {
    if (teamSelect.length > 0) {
      let idsSearch = "";
      let vir = "";
      teamSelect.map((row) => {
        idsSearch += vir + team.find((element) => element.name === row)?.id.toString();
        vir = ",";
      });
      setValues({ ...values, teamId: idsSearch });
    }
  }, [teamSelect]);

  useEffect(() => {
    if (profileSelect.length > 0) {
      let idsSearch: Prof[] = [];
      profileSelect.map((row) => {
        let campo: string = profile.find((element) => element.name === row)?.id.toString() || "";
        idsSearch.push({ profileId: campo });
      });
      setEdit({ ...valuesEdit, profile: idsSearch });
    }
  }, [profileSelect]);

  async function getTypeAgreement(IdCompany: any) {
    try {
      setMsgModal(t("person.waitPesquisa").toString());
      handleOpen();
      const response = await api.get('/typeContract/0?companyId=' + IdCompany)
      if (response.status === 200) {
        const { result } = response.data;
        let retTypeAgreement = await result.map((item: any) => {
          return { id: item.id, name: item.name };
        })
        setTypeContract(retTypeAgreement);
      } else if (response.status === 400) {
        Toast({ type: "warn", message: t("typeContract." + response.data.message) });
      } else {
        Toast({ type: "error", message: t("typeContract." + response.data.message) });
      }
      handleClose();
    } catch (err) {
      handleClose();
      Toast({ type: "error", message: t("typeContract.mensagem-00") });
    }
  };

  async function getTeam(IdCompany: any) {
    try {
      setMsgModal(t("person.waitPesquisa").toString());
      handleOpen();
      setTeam([]);
      const response = await api.get('/team?companyId=' + IdCompany)
      if (response.status === 200) {
        const { result } = response.data;
        let retTeam = [
          { id: -1, name: t("person.SnoTeam") },
          ...await result.map((item: any) => ({ id: item.id, name: item.name }))
        ];
        setTeam(retTeam);
      } else if (response.status === 400) {
        Toast({ type: "warn", message: t("team." + response.data.message) });
      } else {
        Toast({ type: "error", message: t("team." + response.data.message) });
      }
      handleClose();
    } catch (err) {
      handleClose();
      Toast({ type: "error", message: t("team.mensagem-00") });
    }
  };

  async function getIenterval(IdCompany: any) {
    try {
      setMsgModal(t("person.waitPesquisa").toString());
      handleOpen();
      setIenterval([]);
      const response = await api.get('/interval/?companyId=' + IdCompany)
      if (response.status === 200) {
        const { result } = response.data;
        let retIenterval = await result.map((item: any) => {
          return { id: item.id, name: item.name };
        })
        setIenterval(retIenterval);
      } else if (response.status === 400) {
        Toast({ type: "warn", message: t("interval." + response.data.message) });
      } else {
        Toast({ type: "error", message: t("interval." + response.data.message) });
      }
      handleClose();
    } catch (err) {
      handleClose();
      Toast({ type: "error", message: t("interval.mensagem-00") });
    }
  };

  async function openModal(item: any, action: any) {
    if (action === 'insert') {
      setEdit({
        ...valuesEdit,
        action: 0,
        title: t("person.titInclude"),
        id: 0,
        externalCode: "",
        enrollment: "",
        cpf: "",
        name: "",
        familyName: "",
        sex: "",
        phone: "",
        mobile: "",
        email: "",
        cargo: "",
        pis: "",
        dtAdmissao: "",
        ctps: "",
        urlAvatar: 0,
        status: "",
        companyId: values.companyId,
        typeContractId: "",
        intervalId: "",
        teamId: "",
        profile: [],
        logChange: 0
      });
      setDtAdmissao(null);
    } else if (action === 'update' || action === 'delete') {
      setProfileSelect(item.profile.length === 0 ? [] : item.profile.map((item: any) => t("person." + item.profileName)));
      setEdit({
        ...valuesEdit,
        action: (action === 'update') ? 1 : 2,
        title: (action === 'update') ? t("person.titUpdate") : t("person.titDelete"),
        id: item.id,
        externalCode: item.externalCode,
        enrollment: item.enrollment,
        cpf: item.cpf,
        name: item.name,
        familyName: item.familyName,
        sex: item.sex,
        phone: item.phone,
        mobile: item.mobile,
        email: item.email,
        cargo: item.cargo,
        pis: item.pis,
        dtAdmissao: item.dtAdmissao,
        ctps: item.ctps,
        urlAvatar: item.urlAvatar,
        status: item.status,
        companyId: values.companyId,
        typeContractId: item.typeContractId,
        intervalId: item.intervalId,
        teamId: item.teamId,
        profile: item.profile,
        logChange: item.logChange
      });
      setDtAdmissao(dayjs(item.dtAdmissao, 'DD/MM/YYYY'));
    } else {
      setEdit({
        ...valuesEdit,
        action: 3,
        title: t("person.titService") + " " + item.name,
        id: item.id
      });
      setServicePersonSelect('');
      setNotServicePerson([]);
      setServicePerson([]);
      getServicePerson(item.id);
      getNotServicePerson(item.id);
    }
    handleOpenColaborador();
  };

  function clearSearch() {
    setValues({
      ...values,
      enrollment: "",
      name: "",
      email: "",
      status: ""
    });
    setTeamSelect([]);
    setOptions([]);
  };

  //Pesquisar Person
  async function searchPerson() {
    setMsgModal("Pesquisando, aguarde!");
    handleOpen();
    try {
      let query_filter = ''
      if (values.enrollment !== "") {
        query_filter = query_filter + `&enrollment=${values.enrollment}`
      }

      if (values.name !== "") {
        query_filter = query_filter + `&name=${values.name}`
      }

      if (values.email !== "") {
        query_filter = query_filter + `&email=${values.email}`
      }

      if (values.status !== "") {
        query_filter = query_filter + `&status=${values.status}`
      }

      query_filter += `&page=1`;
      setPage(0);
      const response = await api.get("/person?companyId=1" + query_filter);
      if (response.status === 200) {
        const { result } = response.data;
        setOptions(result);
        handleClose();
      } else if (response.status === 400) {
        Toast({ type: "warn", message: response.data.message });
      } else {
        Toast({ type: "error", message: response.data.message });
      }
      handleClose();
    } catch (err) {
      handleClose();
      Toast({ type: "error", message: "Erro Geral, contate o suporte." });
    }
  };

  //Criar Colaborador
  async function saveColaborador() {
    try {
      setMsgModal(t("person.waitUpdating").toString());
      handleOpen();
      debugger
      const response = await api.post("/person?companyId=" + valuesEdit.companyId, valuesEdit);
      if (response.status === 200) {
        handleCloseColaborador();
        Toast({ type: "success", message: response.data.message });
        handleClose();
        clearSearch();
        setOptions([]);
        searchPerson();
      } else if (response.status === 400) {
        handleClose();
        Toast({ type: "warn", message: response.data.message });
      } else {
        handleClose();
        Toast({ type: "error", message:response.data.message });
      }
    } catch (err) {
      handleClose();
      Toast({ type: "error", message: "Erro Geral, contate o suporte." });
    }
  }

  // Apagar Colaborador
  async function deleteColaborador(id: any) {
    try {
      setMsgModal(t("person.waitDeleting").toString());
      handleOpen();
      const response = await api.delete("/person/" + id);
      if (response.status === 200) {
        handleCloseColaborador();
        Toast({ type: "success", message: t("person." + response.data.message) });
        handleClose();
        clearSearch();
        setOptions([]);
        searchPerson();
      } else if (response.status === 400) {
        handleClose();
        Toast({ type: "warn", message: t("person." + response.data.message) });
      } else {
        handleClose();
        Toast({ type: "error", message: t("person." + response.data.message) });
      }
    } catch (err) {
      handleClose();
      Toast({ type: "error", message: t("person.mensagem-00") });
    }
  }

  //Atualizar Colaborador
  async function updateColaborador(id: any) {
    try {
      setMsgModal(t("person.waitUpdating").toString());
      handleOpen();

      const response = await api.put("/person/" + id, valuesEdit);
      if (response.status === 200) {
        handleCloseColaborador();
        Toast({ type: "success", message:  response.data.message });
        handleClose();
        clearSearch();
        setOptions([]);
        searchPerson();
      } else if (response.status === 400) {
        handleClose();
        Toast({ type: "warn", message: response.data.message });
      } else {
        handleClose();
        Toast({ type: "error", message: response.data.message });
      }
    } catch (err) {
      handleClose();
      Toast({ type: "error", message: "Erro Geral, contate o suporte." });
    }
  }

  async function getServicePerson(IdColaborador: any) {
    try {
      setMsgModal(t("person.waitPesquisa").toString());
      handleOpen();
      const response = await api.get('/servicePerson/getService/' + IdColaborador)
      if (response.status === 200) {
        const { result } = response.data;
        setServicePerson(result);
      } else if (response.status === 400) {
        Toast({ type: "warn", message: t("servicePerson." + response.data.message) });
      } else {
        Toast({ type: "error", message: t("servicePerson." + response.data.message) });
      }
      handleClose();
    } catch (err) {
      handleClose();
      Toast({ type: "error", message: t("servicePerson.mensagem-00") });
    }
  };

  async function getNotServicePerson(IdColaborador: any) {
    try {
      setMsgModal(t("person.waitPesquisa").toString());
      handleOpen();
      const response = await api.get("/servicePerson/serviceNotIn/" + IdColaborador)
      if (response.status === 200) {
        const { result } = response.data;
        let retService = await result.map((item: any) => {
          return { id: item.serviceId, name: item.serviceName };
        })
        setNotServicePerson(retService);
      } else if (response.status === 400) {
        Toast({ type: "warn", message: t("servicePerson." + response.data.message) });
      } else {
        Toast({ type: "error", message: t("servicePerson." + response.data.message) });
      }
      handleClose();
    } catch (err) {
      handleClose();
      Toast({ type: "error", message: t("servicePerson.mensagem-00") });
    }
  };

  async function saveServicePerson() {
    try {
      if (servicePersonSelect !== null) {
        setMsgModal(t("person.waitUpdating").toString());
        handleOpen();
        const obj = {
          serviceId: servicePersonSelect,
          personId: valuesEdit.id
        }
        const response = await api.post('/servicePerson/', obj)
        if (response.status === 200) {
          setServicePersonSelect('');
          setNotServicePerson([]);
          setServicePerson([]);
          getServicePerson(valuesEdit.id);
          getNotServicePerson(valuesEdit.id);
        } else if (response.status === 400) {
          Toast({ type: "warn", message: t("servicePerson." + response.data.message) });
        } else {
          Toast({ type: "error", message: t("servicePerson." + response.data.message) });
        }
        handleClose();
      }
    } catch (err) {
      handleClose();
      Toast({ type: "error", message: t("servicePerson.mensagem-00") });
    }
  };

  async function deleteServicePerson(item: any) {
    try {
      setMsgModal(t("person.waitDeleting").toString());
      handleOpen();
      const response = await api.delete('/servicePerson/' + item.id)
      if (response.status === 200) {
        setServicePersonSelect('');
        setNotServicePerson([]);
        setServicePerson([]);
        getServicePerson(valuesEdit.id);
        getNotServicePerson(valuesEdit.id);
      } else if (response.status === 400) {
        Toast({ type: "warn", message: t("servicePerson." + response.data.message) });
      } else {
        Toast({ type: "error", message: t("servicePerson." + response.data.message) });
      }
      handleClose();
    } catch (err) {
      handleClose();
      Toast({ type: "error", message: t("servicePerson.mensagem-00") });
    }
  };

 
 const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  async function handleChange(item: any) {
    let { name, value } = item.target;
    setValues({ ...values, [name]: value });
  }

  async function handleChangeEdit(item: any) {
    let { name, value } = item.target;
    setEdit({ ...valuesEdit, [name]: value });
  };

  const handleChangeProfile = (event: any) => {
    const value = event.target.value;
    if (value[value.length - 1] === "all") {
      setProfileSelect(profileSelect.length === profile.length ? [] : profile.map((lin) => lin.name));
      return;
    }
    setProfileSelect(value);
  };

  const handleDtAdmissao = (iniValue: any | null) => {
    if (iniValue !== null) {
      setDtAdmissao(iniValue);
      setEdit({ ...valuesEdit, dtAdmissao : iniValue.format('DD/MM/YYYY') })
    }
  };

  const modalContent = (
    <Overlay>
      <Content>
        <TitleModal>
          {valuesEdit.title}
        </TitleModal>
        <CloseModal onClick={() => handleCloseColaborador()} />
        {valuesEdit.action <= 1 ?
          <>
            <TextField
              sx={styleInput}
              style={{ width: '15%' }}
              size="small"
              variant="outlined"
              label={t("person.SRegistration")}
              type="text"
              required
              name="enrollment"
              value={valuesEdit.enrollment}
              onChange={handleChangeEdit}
            />
            <TextField
              sx={styleInput}
              style={{ width: '50%' }}
              size="small"
              variant="outlined"
              label={t("person.Sname")}
              type="text"
              required
              name="name"
              value={valuesEdit.name}
              onChange={handleChangeEdit}
            />
            <TextField
              sx={styleInput}
              style={{ width: '25%' }}
              size="small"
              variant="outlined"
              label={t("person.SfamilyName")}
              type="text"
              required
              name="familyName"
              value={valuesEdit.familyName}
              onChange={handleChangeEdit}
            />
            <TextField
              sx={styleInput}
              style={{ width: '15%' }}
              size="small"
              variant="outlined"
              label={t("person.SexternalCode")}
              type="text"
              name="externalCode"
              value={valuesEdit.externalCode}
              onChange={handleChangeEdit}
            />
            <TextField
              sx={styleInput}
              style={{ width: '50%' }}
              size="small"
              variant="outlined"
              label={t("person.Semail")}
              type="text"
              required
              name="email"
              value={valuesEdit.email}
              onChange={handleChangeEdit}
            />
            <FormControl sx={{ m: 1, minWidth: 50, width: '25%', backgroundColor: colors.c01 }} size="small">
              <InputLabel sx={{ color: colors.c04 }} required id="sex">{t("person.Ssex")}</InputLabel>
              <Select
                sx={styleSelect}
                labelId="sex"
                id="sex"
                value={valuesEdit.sex}
                label={t("person.Ssex")}
                onChange={(e) => setEdit({ ...valuesEdit, sex: e.target.value })}
              >
                {sex.map((row: any, index) => (
                  <MenuItem sx={styleMenuSelect} value={row.id}>{row.name}</MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl sx={{ m: 0, minWidth: 50, width: '24%', backgroundColor: colors.c01 }} size="small">
              <InputMask
                mask="999.999.999-99"
                name="cpf"
                value={valuesEdit.cpf}
                onChange={handleChangeEdit}
              >
                {() => <TextField sx={styleInput} size="small" variant="outlined" name="cpf" type="text" label={t("person.Scpf")} />}
              </InputMask>
            </FormControl>
            <FormControl sx={{ m: 0, minWidth: 50, width: '23%', backgroundColor: colors.c01 }} size="small">
              <InputMask
                mask="(99)99999 9999"
                name="mobile"
                value={valuesEdit.mobile}
                onChange={handleChangeEdit}
              >
                {() => <TextField sx={styleInput} required size="small" variant="outlined" name="mobile" type="text" label={t("person.Smobile")} />}
              </InputMask>
            </FormControl>
            <FormControl sx={{ m: 0, minWidth: 50, width: '23%', backgroundColor: colors.c01 }} size="small">
              <InputMask
                mask="(99)9999 9999"
                name="phone"
                value={valuesEdit.phone}
                onChange={handleChangeEdit}
              >
                {() => <TextField sx={styleInput} size="small" variant="outlined" name="phone" type="text" label={t("person.Sphone")} />}
              </InputMask>
            </FormControl>
            <FormControl sx={{ m: 1, minWidth: 100, width: '25%', backgroundColor: colors.c01 }} size="small">
              <InputLabel sx={{ color: colors.c04 }} required id="profile">{t("person.SProfile")}</InputLabel>
              <Select
                sx={styleSelect}
                multiple
                labelId="profile"
                id="profile"
                value={profileSelect}
                label={t("person.SProfile")}
                onChange={handleChangeProfile}
                renderValue={(profileSelect) => profileSelect.join(", ")}
              >
                {profile.length > 0 &&
                  <MenuItem value="all" sx={styleMenuSelect}>
                    <ListItemIcon>
                      <Checkbox sx={{ color: colors.c04 }}
                        checked={isAllProfileSelected}
                        indeterminate={
                          profileSelect.length > 0 && profileSelect.length < profile.length
                        }
                      />
                    </ListItemIcon>
                    <ListItemText
                      primary={t("person.SelectAll")}
                    />
                  </MenuItem>
                }
                {profile.map((row: any, index) => (
                  <MenuItem key={row.name} value={row.name} sx={styleMenuSelect}>
                    <Checkbox sx={{ color: colors.c04 }} checked={profileSelect.indexOf(row.name) > -1} />
                    <ListItemText primary={row.name} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl sx={{ m: 1, minWidth: 150, width: '45%', backgroundColor: colors.c01 }} size="small">
              <InputLabel sx={{ color: colors.c04 }} required id="team">{t("person.Steam")}</InputLabel>
              <Select
                sx={styleSelect}
                labelId="team"
                id="team"
                value={valuesEdit.teamId}
                label={t("person.Steam")}
                onChange={(e) => setEdit({ ...valuesEdit, teamId: e.target.value })}
              >
                {team.map((row: any, index) => (
                  <MenuItem sx={styleMenuSelect} value={row.id}>{row.name}</MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl sx={{ m: 1, minWidth: 150, width: '21%', backgroundColor: colors.c01 }} size="small">
              <InputLabel sx={{ color: colors.c04 }} required id="typeContractId">{t("person.StypeContract")}</InputLabel>
              <Select
                sx={styleSelect}
                labelId="typeContractId"
                id="typeContractId"
                value={valuesEdit.typeContractId}
                label={t("person.StypeContract")}
                onChange={(e) => setEdit({ ...valuesEdit, typeContractId: e.target.value })}
              >
                {typeContract.map((row: any, index) => (
                  <MenuItem sx={styleMenuSelect} value={row.id}>{row.name}</MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl sx={{ m: 1, minWidth: 150, width: '25%', backgroundColor: colors.c01 }} size="small">
              <InputLabel sx={{ color: colors.c04 }} required id="intervalId">{t("person.Sinterval")}</InputLabel>
              <Select
                sx={styleSelect}
                labelId="intervalId"
                id="intervalId"
                value={valuesEdit.intervalId}
                label={t("person.Sinterval")}
                onChange={(e) => setEdit({ ...valuesEdit, intervalId: e.target.value })}
              >
                {interval.map((row: any, index) => (
                  <MenuItem sx={styleMenuSelect} value={row.id}>{row.name}</MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl sx={{ m: 0, minWidth: 150, width: '23%', backgroundColor: colors.c01 }} size="small">
                <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="pt-br">
                  <DesktopDatePicker
                    label="Data Admissão"
                    sx={styleInput}
                    value={dtAdmissao}
                    onChange={(eventInt) => handleDtAdmissao(eventInt)}
                    slotProps={{
                      textField: { size: 'small' },
                      calendarHeader: { sx: { backgroundColor: colors.c17, color: colors.c04 } },
                      previousIconButton: { sx: { color: colors.c04 } },
                      nextIconButton: { sx: { color: colors.c04 } },
                      day: { sx: { backgroundColor: colors.c01, color: colors.c04 } },
                      desktopPaper: { sx: { backgroundColor: colors.c17, color: colors.c04 } }
                    }}
                  />
                </LocalizationProvider>
              </FormControl>
              <TextField
              sx={styleInput}
              style={{ width: '32%' }}
              size="small"
              variant="outlined"
              label="Cargo"
              type="text"
              required
              name="cargo"
              value={valuesEdit.cargo}
              onChange={handleChangeEdit}
            />
            <TextField
              sx={styleInput}
              style={{ width: '20%' }}
              size="small"
              variant="outlined"
              label="PIS"
              type="text"
              required
              name="pis"
              value={valuesEdit.pis}
              onChange={handleChangeEdit}
            />
            <TextField
              sx={styleInput}
              style={{ width: '15%' }}
              size="small"
              variant="outlined"
              label="Nº CTPS"
              type="text"
              required
              name="ctps"
              value={valuesEdit.ctps}
              onChange={handleChangeEdit}
            />
            <FormControl sx={{ m: 1, minWidth: 150, width: '15%', backgroundColor: colors.c01 }} size="small">
              <InputLabel sx={{ color: colors.c04 }} required id="status">{t("person.Sstatus")}</InputLabel>
              <Select
                sx={styleSelect}
                labelId="status"
                id="status"
                value={valuesEdit.status}
                label={t("person.Sstatus")}
                onChange={(e) => setEdit({ ...valuesEdit, status: e.target.value })}
              >
                {status.map((row: any, index) => (
                  <MenuItem sx={styleMenuSelect} value={row.id}>{row.name}</MenuItem>
                ))}
              </Select>
            </FormControl>
            <Box sx={{ '& button': { m: 1 } }}>
              <BtnCancel
                onClick={handleCloseColaborador} sx={{ float: 'right', backgroundColor: colors.c13, '&:hover': { opacity: 0.7, backgroundColor: colors.c13} }} variant="contained">
                <CloseIcon sx={{ fontSize: '16px', marginRight: '7px' }} />{t("person.Cancel")}
              </BtnCancel>
              <Btn sx={{backgroundColor: colors.c02, '&:hover': { opacity: 0.7, backgroundColor: colors.c02}}}
                onClick={() => valuesEdit.action === 0 ? saveColaborador() : updateColaborador(valuesEdit.id)} variant="contained">
                <CheckIcon sx={{ fontSize: '16px', marginRight: '7px' }} />{t("person.Save")}
              </Btn>
            </Box>
          </>
          : valuesEdit.action === 2 ?
            <>
              <Box sx={{ margin: '10px' }}>
                <h3>{t("person.msgRemover")} "{valuesEdit.name}" ?</h3>
              </Box>
              <Box sx={{ '& button': { m: 1 } }}>
                <BtnCancel
                  onClick={handleCloseColaborador} sx={{ float: 'right', backgroundColor: colors.c13, '&:hover': { opacity: 0.7, backgroundColor: colors.c13} }} variant="contained">
                  <CloseIcon sx={{ fontSize: '16px', marginRight: '7px' }} />{t("person.Cancel")}
                </BtnCancel>
                <Btn sx={{backgroundColor: colors.c02, '&:hover': { opacity: 0.7, backgroundColor: colors.c02}}}
                  onClick={() => deleteColaborador(valuesEdit.id)} variant="contained">
                  <DeleteForeverIcon sx={{ fontSize: '16px', marginRight: '7px' }} />{t("person.Remove")}
                </Btn>
              </Box>
            </>
            : valuesEdit.action === 3 ?
              <>
                <FormControl sx={{ m: 1, minWidth: 150, width: '40ch', backgroundColor: colors.c01 }} size="small">
                  <InputLabel sx={{ color: colors.c04 }} id="servicePerson">{t("person.services")}</InputLabel>
                  <Select
                    sx={styleSelect}
                    labelId="servicePerson"
                    id="servicePerson"
                    value={servicePersonSelect}
                    label={t("person.services")}
                    onChange={(e) => setServicePersonSelect(e.target.value)}
                  >
                    {notServicePerson.map((row: any, index) => (
                      <MenuItem sx={styleMenuSelect} value={row.id}>{row.name}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <Btn onClick={() => saveServicePerson()} sx={{backgroundColor: colors.c02, '&:hover': { opacity: 0.7, backgroundColor: colors.c02}}} variant="contained"> 
                  <CheckIcon sx={{ fontSize: '16px', marginRight: '7px' }} />{t("service.Associate")}
                </Btn>
                <TableContainer sx={{ width: '100%', height: '400px', backgroundColor: colors.c01, borderRadius: '5px', marginBottom: '50px', overflow: "auto" }} >
                  <Table stickyHeader aria-label="sticky table" size={'small'}>
                    <TableHead>
                      <TableRow>
                        <TableCell style={{ backgroundColor: colors.c02, color: colors.c05, fontWeight: 'bold', border: 'none', fontSize: '11px' }} align="center" >{t("person.servicerM")}</TableCell>
                        <TableCell style={{ backgroundColor: colors.c02, color: colors.c05, fontWeight: 'bold', border: 'none', fontSize: '11px' }} align="center" >{t("person.Actions")}</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {
                        servicePerson && servicePerson.map((row, index) => {
                          return (
                            <TableRow style={{ backgroundColor: index % 2 === 0 ? colors.c17 : shade(0.1, colors.c17) }} key={index}>
                              <TableCell style={{ color: colors.c04, border: 'none', fontSize: '12px' }} component="th" scope="row" align="center">
                                {row.serviceName}
                              </TableCell>
                              <TableCell style={{ color: colors.c04, border: 'none', fontSize: '12px' }} component="th" scope="row" align="center">
                                <AiTwotoneDelete
                                  style={{ cursor: "pointer", marginLeft: "5px" }}
                                  color={colors.c04}
                                  size="20"
                                  title={t("person.Remove").toString()}
                                  onClick={() => deleteServicePerson(row)}
                                />
                              </TableCell>
                            </TableRow>
                          )
                        })
                      }
                    </TableBody>
                  </Table>
                </TableContainer>
              </> : <></>
        }
      </Content>
    </Overlay>

  );

  return (
    <Box sx={style}>
      <h4>{t("person.title")}</h4><Box py={1} />
      <Grid container spacing={2} direction="row">
        <Box px={0.5} />
        <TextField
          sx={styleInput}
          style={{ width: '8%' }}
          size="small"
          variant="outlined"
          label={t("person.SRegistration")}
          type="text"
          name="enrollment"
          value={values.enrollment}
          onChange={handleChange}
        />
        <TextField
          sx={styleInput}
          style={{ width: '20%' }}
          size="small"
          variant="outlined"
          label={t("person.Sname")}
          type="text"
          name="name"
          value={values.name}
          onChange={handleChange}
        />
        <TextField
          sx={styleInput}
          style={{ width: '20%' }}
          size="small"
          variant="outlined"
          label={t("person.Semail")}
          type="text"
          name="email"
          value={values.email}
          onChange={handleChange}
        />
        <FormControl sx={{ m: 1, minWidth: 100, width: '6%', backgroundColor: colors.c01 }} size="small">
          <InputLabel sx={{ color: colors.c04 }} id="status">{t("person.Sstatus")}</InputLabel>
          <Select
            sx={styleSelect}
            labelId="status"
            id="status"
            value={values.status}
            label={t("team.Sstatus")}
            onChange={(e) => setValues({ ...values, status: e.target.value })}
          >
            {status.map((row: any, index) => (
              <MenuItem sx={styleMenuSelect} value={row.id}>{row.name}</MenuItem>
            ))}
          </Select>
        </FormControl>

        <Tooltip title="Consultar" placement="bottom-start" arrow>
          <Button size="small" onClick={() => searchPerson()}
              sx={{ marginTop: '9px', marginBottom: '10px', backgroundColor: colors.c19, '&:hover': { opacity: 0.7, backgroundColor: colors.c19 } }}
              aria-label="Consultar">
              <IconeSearch size={18} color={colors.c05} />
          </Button>
        </Tooltip>
        <Box px={3} />
        <Tooltip title={t("person.clean")} placement="bottom-start" arrow>
          <Button size="small" onClick={() => clearSearch()}
            sx={{ marginTop: '9px', marginBottom: '10px', backgroundColor: colors.c13, '&:hover': { opacity: 0.7, backgroundColor: colors.c13 } }}
            aria-label={t("person.clean")}>
            <IconClear size={19} color={colors.c05} />
          </Button>
        </Tooltip>
      </Grid>
      <TableContainer sx={{ maxHeight: 400, backgroundColor: colors.c01, borderRadius: '5px' }} >
        <Table stickyHeader aria-label="sticky table" size={'small'}>
          <TableHead>
            <TableRow>
              <TableCell style={{ backgroundColor: colors.c02, color: colors.c05, fontWeight: 'bold', border: 'none', fontSize: '12px' }} align="center" >{t("person.registrationM")}</TableCell>
              <TableCell style={{ backgroundColor: colors.c02, color: colors.c05, fontWeight: 'bold', border: 'none', fontSize: '12px' }} align="center" >{t("person.nameM")}</TableCell>
              <TableCell style={{ backgroundColor: colors.c02, color: colors.c05, fontWeight: 'bold', border: 'none', fontSize: '12px' }} align="center" >{t("person.emailM")}</TableCell>
              <TableCell style={{ backgroundColor: colors.c02, color: colors.c05, fontWeight: 'bold', border: 'none', fontSize: '12px' }} align="center" >{t("person.teamM")}</TableCell>
              <TableCell style={{ backgroundColor: colors.c02, color: colors.c05, fontWeight: 'bold', border: 'none', fontSize: '12px' }} align="center" >{t("person.statusM")}</TableCell>
              <TableCell style={{ backgroundColor: colors.c02, color: colors.c05, fontWeight: 'bold', border: 'none', fontSize: '11px' }} align="center" >{t("person.Actions")}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {
              valuesPerson && valuesPerson.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => {
                return (
                  <TableRow style={{ backgroundColor: index % 2 === 0 ? colors.c17 : shade(0.1, colors.c17) }} key={index}>
                    <TableCell style={{ color: colors.c04, border: 'none', fontSize: '12px' }} component="th" scope="row" align="center">
                      {row.enrollment}
                    </TableCell>
                    <TableCell style={{ color: colors.c04, border: 'none', fontSize: '12px' }} component="th" scope="row" align="center">
                      {row.name}
                    </TableCell>
                    <TableCell style={{ color: colors.c04, border: 'none', fontSize: '12px' }} component="th" scope="row" align="center">
                      {row.email}
                    </TableCell>
                    <TableCell style={{ color: colors.c04, border: 'none', fontSize: '12px' }} component="th" scope="row" align="center">
                      {row.teamName}
                    </TableCell>
                    <TableCell style={{ color: colors.c04, border: 'none', fontSize: '12px' }} component="th" scope="row" align="center">
                      {row.status === 1 ? t("person.active") : t("person.inactive")}
                    </TableCell>
                    <TableCell
                      style={{ color: colors.c04, border: 'none', fontSize: '12px' }} component="th" scope="row" align="center">
                      <FiEdit
                        style={{ cursor: 'pointer', marginLeft: "5px" }}
                        color={tint(0.1, colors.c04)}
                        size="20"
                        title={t("person.Edit").toString()}
                        onClick={() => openModal(row, 'update')}
                      />
                    </TableCell>
                  </TableRow>
                )
              })
            }
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination sx={{ color: colors.c04 }}
        rowsPerPageOptions={[9]}
        component="div"
        count={valuesPerson.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
      <Box sx={{ textAlign: 'center', alignContent: 'center' }}>
        <Backdrop
          sx={(theme) => ({ color: colors.c04, zIndex: theme.zIndex.drawer + 1 })}
          open={open}
          onClick={handleClose}
        >
          <CircularProgress color="inherit" />
          <Box px={1} />
          {msgModal}
        </Backdrop>
      </Box>
      <Modal open={openColaborador}
        onClose={handleCloseColaborador}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        {modalContent}
      </Modal>
      
    </Box>
  );
}